import { Redirect } from 'expo-router';
import * as React from 'react';
import {
    BodyMediumRegular,
    Button,
    ButtonSize,
    ButtonVariant,
    H5Emphasized,
    InfoRow,
    RowList,
    View,
    YStack,
} from 'smoothie';

import { useAuthedUser } from '../../../../../common/providers/AuthedUserProvider';
import { formatMailingAddress } from '../../../../../common/utils/userUtils';
import { captureException } from '../../../../../logger/Logger';

interface AddressProps {
    embossName: string;
    lostOrStolen: boolean;
    onPress: () => void;
    onPressUseNewAddress: () => void;
}

const Address = ({
    embossName,
    lostOrStolen,
    onPress,
    onPressUseNewAddress,
}: AddressProps) => {
    const user = useAuthedUser();

    const { userAddress } = user;

    if (userAddress == null) {
        captureException(
            new Error('Address not found for user attempting to reissue card'),
            { user },
        );
        // TODO: Maybe show a toast notification to the user encouraging them to contact HD?
        return <Redirect href="/home/banking" />;
    }

    return (
        <YStack flex={1} justifyContent="space-between">
            <YStack gap={6}>
                <H5Emphasized>
                    Confirm where you want your replacement physical card sent
                </H5Emphasized>
                <BodyMediumRegular color="$gray1000">
                    This is the address we have on file.
                </BodyMediumRegular>

                <YStack marginTop={20}>
                    <RowList>
                        <InfoRow
                            title="Mailing address"
                            value={formatMailingAddress(userAddress)}
                        />
                        <InfoRow title="Name on card" value={embossName} />
                        <InfoRow
                            title="Arrives in mail"
                            value="5-7 business days"
                        />
                    </RowList>
                </YStack>
            </YStack>
            <View gap={12}>
                <Button
                    variant={ButtonVariant.SECONDARY}
                    onPress={onPressUseNewAddress}
                    size={ButtonSize.LARGE}
                    text="Use a different address"
                />
                <Button
                    variant={ButtonVariant.PRIMARY}
                    onPress={onPress}
                    size={ButtonSize.LARGE}
                    text={!lostOrStolen ? 'Send my new card' : 'Confirm'}
                />
            </View>
        </YStack>
    );
};

export default Address;
